import moment from 'moment';

export default function genererLigneEcheancier() {
  return {
    dateDebut: null,
    dateFin: null,
    datePrevisionnelleFacturation: null,
    facturationFaite: false,
    facture: null,
    factureId: null,
    montant: 0,
    tiersId: null,
    fromGeneration: true,
  };
}
export function genererLigneEcheancierForAuto() {
  return {
    commentaireFacturation: null,
    dateDebut: moment(),
    dateFin: moment(),
    datePrevisionnelleFacturation: moment(),
  };
}
